import React from 'react';
import Axios from 'axios';

import { LoadingOutlined } from '@ant-design/icons';
import { Spin, Result, Button } from 'antd';
import { Link } from 'react-router-dom';

import { Config } from './config_section.js';
import './CSProfiler.scss';
import Statistics from './statistics/Statistics.js';
import CSPIntersection from './intersection/CSPIntersection.js';
import Certifications from './certifications/Certifications.js';
import Trainings from './trainings/Trainings.js';
import Curricula from './curricula/Curricula.js';
import StudyProfiler from './study-profiler/StudyProfiler.js';

const CSProfiler = ({ section, showMessage }) => {
  const [dbCertifications, setDbCertifications] = React.useState(null);
  const [dbStudyPrograms, setDbStudyPrograms] = React.useState(null);
  const [dbTrainings, setDbTrainings] = React.useState(null);
  const [rsSkillsGroup, setRsSkillsGroup] = React.useState(null);
  const [rsSpecificKnowledge, setRsSpecificKnowledge] = React.useState(null);
  const [rsSpecificSkills, setRsSpecificSkills] = React.useState(null);
  const [rsProfiles, setRsProfiles] = React.useState(null);
  const [dbDomains, setDbDomains] = React.useState(null);
  const [dbECSFRoles, setDbECSFRoles] = React.useState(null);

  React.useEffect(() => {
    getData();
  }, []);

  function getData() {
    setDbCertifications(null);
    setDbStudyPrograms(null);
    setDbTrainings(null);
    setRsSkillsGroup(null);
    setRsSpecificKnowledge(null);
    setRsSpecificSkills(null);
    setRsProfiles(null);
    setDbDomains(null);
    setDbECSFRoles(null);
    Axios.get(Config.server.getData)
      .then((response) => {
        if (response && response.data.error === false) {
          setDbCertifications(response.data.data.certifications);
          setDbStudyPrograms(response.data.data.study_programs);
          setDbTrainings(response.data.data.trainings);
          setRsSkillsGroup(response.data.data.rs_skill_group);
          setRsSpecificKnowledge(response.data.data.rs_specific_knowledge);
          setRsSpecificSkills(response.data.data.rs_specific_skills);
          setRsProfiles(response.data.data.rs_profiles);
          setDbDomains(response.data.data.csp_domains);
          setDbECSFRoles(response.data.data.csp_ecsf_roles);
        } else {
          console.log(response.data.message);
          setDbCertifications(0);
          setDbStudyPrograms(0);
          setDbTrainings(0);
          setRsSkillsGroup(0);
          setRsSpecificKnowledge(0);
          setRsSpecificSkills(0);
          setRsProfiles(0);
          setDbDomains(0);
          setDbECSFRoles(0);
        }
      })
      .catch((error) => {
        console.log('Server is unavailable');
        console.log(error);
        setDbCertifications(0);
        setDbStudyPrograms(0);
        setDbTrainings(0);
        setRsSkillsGroup(0);
        setRsSpecificKnowledge(0);
        setRsSpecificSkills(0);
        setRsProfiles(0);
        setDbDomains(0);
        setDbECSFRoles(0);
      });
  }

  function dataStatus() {
    if (
      dbCertifications === null &&
      dbStudyPrograms === null &&
      dbTrainings === null &&
      rsSkillsGroup === null &&
      rsSpecificKnowledge === null &&
      rsSpecificSkills === null &&
      rsProfiles === null &&
      dbDomains === null &&
      dbECSFRoles === null
    ) {
      return 'loading';
    } else if (
      Array.isArray(dbCertifications) &&
      Array.isArray(dbStudyPrograms) &&
      Array.isArray(dbTrainings) &&
      Array.isArray(rsSkillsGroup) &&
      Array.isArray(rsSpecificKnowledge) &&
      Array.isArray(rsSpecificSkills) &&
      Array.isArray(rsProfiles) &&
      Array.isArray(dbDomains) &&
      Array.isArray(dbECSFRoles)
    ) {
      return 'ok';
    } else {
      return 'error';
    }
  }

  return (
    <section id="csprofiler" className="CSProfiler">
      {dataStatus() === 'loading' ? (
        <div className="vertCenter">
          <Spin tip="Loading..." indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      ) : dataStatus() === 'error' ? (
        <div className="vertCenter">
          <Result
            status="500"
            title="500"
            subTitle="Sorry, something went wrong."
            extra={<Link to="/"><Button type="primary">Back Home</Button></Link>}
          />
        </div>
      ) : section === 'csprofiler-statistics' ? (
        <Statistics
          dbCertifications={dbCertifications}
          dbTrainings={dbTrainings}
          dbStudyPrograms={dbStudyPrograms}
          rsSkillsGroup={rsSkillsGroup}
          rsSpecificKnowledge={rsSpecificKnowledge}
          rsSpecificSkills={rsSpecificSkills}
          rsProfiles={rsProfiles}
        />
      ) : section === 'csprofiler-certs' ? (
        <Certifications
          dbCertifications={dbCertifications}
          rsSkillsGroup={rsSkillsGroup}
          rsSpecificKnowledge={rsSpecificKnowledge}
          rsSpecificSkills={rsSpecificSkills}
          rsProfiles={rsProfiles}
          dbDomains={dbDomains}
          dbECSFRoles={dbECSFRoles}
        />
      ) : section === 'csprofiler-trainings' ? (
        <Trainings dbTrainings={dbTrainings} rsSkillsGroup={rsSkillsGroup} rsSpecificKnowledge={rsSpecificKnowledge} rsSpecificSkills={rsSpecificSkills} rsProfiles={rsProfiles} />
      ) : section === 'csprofiler-study-profiler' ? (
        <StudyProfiler
          showMessage={showMessage}
          dbStudyPrograms={dbStudyPrograms}
          rsSkillsGroup={rsSkillsGroup}
          rsSpecificKnowledge={rsSpecificKnowledge}
          rsSpecificSkills={rsSpecificSkills}
          rsProfiles={rsProfiles}
        />
      ) : section === 'csprofiler-intersection' ? (
        <CSPIntersection />
      ) : (
        <Curricula
          showMessage={showMessage}
          dbStudyPrograms={dbStudyPrograms}
          rsSkillsGroup={rsSkillsGroup}
          rsSpecificKnowledge={rsSpecificKnowledge}
          rsSpecificSkills={rsSpecificSkills}
          rsProfiles={rsProfiles}
        />
      )}
    </section>
  );
};

export default CSProfiler;
